import { useCallback, useMemo } from "react";

const useWebViewBridge = () => {
  const sendMessageToReactNative = useCallback((message) => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(message);
    } else {
      console.error("ReactNativeWebView not available");
    }
  }, []);

  return useMemo(
    () => ({
      sendMessageToReactNative,
    }),
    [sendMessageToReactNative]
  );
};

export default useWebViewBridge;
